// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"_variables__pc_only___ev4j5","sp_only":"_variables__sp_only___1OBkb"};